
import getProp from '@f/get-prop'
import { createSelector } from 'reselect'
import { getSourceSettingsArray } from './sources'
import { getSourceTrackEventsData } from './source-track-events'
import { isWorkspaceUsingWarehouseFilters } from './warehouses'

/**
 * Private selectors.
 */

const getWorkspacesBySlug = state => state.workspacesBySlug

/**
 * Get list of workspaces.
 */

export const getWorkspaces = createSelector(getWorkspacesBySlug, workspacesBySlug => {
  const { data } = workspacesBySlug
  const workspaces = []
  for (const slug in data) {
    workspaces.push(data[slug].data)
  }
  return workspaces
})

/**
 * Get a workspace by slug
 */

export function getWorkspace (state, slug) {
  const workspaces = getWorkspacesBySlug(state)

  return getProp(`data.${slug}.data`, workspaces)
}

/**
 * Get a workspace's owner count by slug
 */

export function getWorkspaceOwnerCount (state, slug) {
  const workspace = getWorkspace(state, slug)
  return getProp('owners.length', workspace) || 0
}

/**
 * Get status of request for workspaces
 */

export const getWorkspacesRequest = createSelector(getWorkspacesBySlug, workspacesBySlug => ({
  isRequesting: workspacesBySlug.isRequesting,
  didRequestFail: workspacesBySlug.didRequestFail
}))

export function getWorkspaceTrackEvents (state, workspaceSlug) {
  const sources = getSourceSettingsArray(state, workspaceSlug) || []
  const events = []
  for (let i = 0; i < sources.length; i++) {
    const source = sources[i]
    const data = getSourceTrackEventsData(state, workspaceSlug, source.slug)

    for (const eventName in data) {
      if (!data.hasOwnProperty(eventName)) continue
      const event = data[eventName]
      events.push(event)
    }
  }
  return events
}

export function getWorkspaceFilteredEvents (state, workspaceSlug) {
  const events = getWorkspaceTrackEvents(state, workspaceSlug)
  const filtered = []
  for (let i = 0; i < events.length; i++) {
    const event = events[i]
    if (isTrackEventFiltered(event)) {
      filtered.push(event)
    }
  }
  return filtered
}

function isTrackEventFiltered (event) {
  if (event.enabled === false) return true
  const { integrations = {} } = event
  for (const name in integrations) {
    if (integrations[name] === false) return true
  }
  return false
}

export function isWorkspaceUsingFilters (state, workspaceSlug) {
  const filteredEvents = getWorkspaceFilteredEvents(state, workspaceSlug)
  if (filteredEvents.length > 0) return true
  return isWorkspaceUsingWarehouseFilters(state, workspaceSlug)
}

/**
 * Check if the given `userId` is an owner of `workspaceSlug`.
 */

export function isUserWorkspaceOwner (state, userId, workspaceSlug) {
  const workspace = getWorkspace(state, workspaceSlug) || {}
  const { owners = [] } = workspace
  return !!owners.find(id => id === userId)
}



// WEBPACK FOOTER //
// ./selectors/workspaces.js